// src/pages/services/CustomSoftwareDevelopment.jsx
import React from 'react';
import ServiceTemplate from '../../components/services/ServiceTemplate';
import customSoftwareImg from '../../assets/images/expertise.jpg';

const CustomSoftwareDevelopment = () => {
  const features = [
    {
      icon: '🎯',
      title: 'Tailored Solutions',
      description: 'Software built specifically for your unique business challenges and operational needs'
    },
    {
      icon: '⚡',
      title: 'Agile Development',
      description: 'Rapid, iterative development ensuring quick delivery and continuous improvement'
    },
    {
      icon: '🔒',
      title: 'Enterprise Security',
      description: 'Bank-grade security measures including encryption and authentication'
    },
    {
      icon: '🔄',
      title: 'Full-Cycle Support',
      description: 'From initial concept to deployment and ongoing maintenance'
    },
    {
      icon: '📊',
      title: 'Scalable Architecture',
      description: 'Built to grow with your business needs and handle increasing demands'
    },
    {
      icon: '🔌',
      title: 'API Integration',
      description: 'Seamless integration with your existing tools and systems'
    }
  ];

  const benefits = [
    'Address specific operational needs with precision',
    'Solve unique business challenges effectively',
    'Built with your requirements in mind from day one',
    'Agile development methodology for faster delivery',
    'Full-cycle development support and maintenance',
    'Competitive advantage through custom technology'
  ];

  const technologies = [
    { icon: '⚛️', name: 'React / Next.js' },
    { icon: '🐍', name: 'Python / Django' },
    { icon: '☕', name: 'Java / Spring' },
    { icon: '🗄️', name: 'PostgreSQL / MongoDB' },
    { icon: '☁️', name: 'AWS / Azure' },
    { icon: '🐳', name: 'Docker / Kubernetes' },
    { icon: '📱', name: 'React Native' },
    { icon: '🔧', name: 'RESTful APIs' }
  ];

  const industries = [
    'Construction', 'Manufacturing', 'Mining', 'Oil & Gas', 
    'Food Industry', 'Logistics', 'Real Estate', 'Education', 
    'Healthcare', 'Finance'
  ];

  const process = [
    { title: 'Discovery', description: 'Understanding your requirements and business goals' },
    { title: 'Planning', description: 'Strategic roadmap and architecture design' },
    { title: 'Development', description: 'Agile sprints with regular feedback loops' },
    { title: 'Deployment', description: 'Smooth launch and seamless integration' }
  ];

  return (
    <ServiceTemplate
      title="Custom Software Development"
      badge="CUSTOM DEVELOPMENT"
      description="Tailored software solutions designed to address unique business challenges and operational needs. We build scalable, secure, and innovative systems that give you a competitive edge."
      heroImage={customSoftwareImg}
      features={features}
      benefits={benefits}
      technologies={technologies}
      industries={industries}
      process={process}
      ctaText="Start Your Project"
      ctaLink="/contact"
    />
  );
};

export default CustomSoftwareDevelopment;